import { Checkbox, Stack, Text } from "@mantine/core";
import { CaseDeliveryMethodConfig } from "../../services/signOff.service";

interface DeliveryMethodChecklistContentProps {
  methods: CaseDeliveryMethodConfig[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export function DeliveryMethodChecklistContent({
  methods,
  selectedIds,
  onChange,
}: DeliveryMethodChecklistContentProps) {
  const physicianMethods = methods.filter(
    (m) => m.recipientType === "physician"
  );
  const practiceMethods = methods.filter((m) => m.recipientType === "practice");
  const surgeryCenterMethods = methods.filter(
    (m) => m.recipientType === "surgery_center"
  );
  const labMethods = methods.filter((m) => m.recipientType === "lab");

  const toggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((s) => s !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Select the delivery methods to send the report through. All are selected
        by default.
      </Text>

      {physicianMethods.length > 0 && (
        <Stack gap="xs">
          <Text size="xs" fw={600} tt="uppercase" c="dimmed">
            Physician
          </Text>
          {physicianMethods.map((m) => (
            <Checkbox
              key={m.id}
              label={
                <Stack gap={0}>
                  <Text size="sm">{m.deliveryMethodName}</Text>
                  <Text size="xs" c="dimmed">
                    {m.recipientName}
                    {m.destination ? ` — ${m.destination}` : ""}
                  </Text>
                </Stack>
              }
              checked={selectedIds.includes(m.id)}
              onChange={() => toggle(m.id)}
              color="gcpBlue"
            />
          ))}
        </Stack>
      )}

      {practiceMethods.length > 0 && (
        <Stack gap="xs">
          <Text size="xs" fw={600} tt="uppercase" c="dimmed">
            Practice
          </Text>
          {practiceMethods.map((m) => (
            <Checkbox
              key={m.id}
              label={
                <Stack gap={0}>
                  <Text size="sm">{m.deliveryMethodName}</Text>
                  <Text size="xs" c="dimmed">
                    {m.recipientName}
                    {m.destination ? ` — ${m.destination}` : ""}
                  </Text>
                </Stack>
              }
              checked={selectedIds.includes(m.id)}
              onChange={() => toggle(m.id)}
              color="gcpBlue"
            />
          ))}
        </Stack>
      )}

      {surgeryCenterMethods.length > 0 && (
        <Stack gap="xs">
          <Text size="xs" fw={600} tt="uppercase" c="dimmed">
            Surgical Center
          </Text>
          {surgeryCenterMethods.map((m) => (
            <Checkbox
              key={m.id}
              label={
                <Stack gap={0}>
                  <Text size="sm">{m.deliveryMethodName}</Text>
                  <Text size="xs" c="dimmed">
                    {m.recipientName}
                    {m.destination ? ` — ${m.destination}` : ""}
                  </Text>
                </Stack>
              }
              checked={selectedIds.includes(m.id)}
              onChange={() => toggle(m.id)}
              color="gcpBlue"
            />
          ))}
        </Stack>
      )}

      {labMethods.length > 0 && (
        <Stack gap="xs">
          <Text size="xs" fw={600} tt="uppercase" c="dimmed">
            Lab
          </Text>
          {labMethods.map((m) => (
            <Checkbox
              key={m.id}
              label={
                <Stack gap={0}>
                  <Text size="sm">{m.deliveryMethodName}</Text>
                  <Text size="xs" c="dimmed">
                    {m.recipientName}
                    {m.destination ? ` — ${m.destination}` : ""}
                  </Text>
                </Stack>
              }
              checked={selectedIds.includes(m.id)}
              onChange={() => toggle(m.id)}
              color="gcpBlue"
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
